import MainButton from "../../Component/Button/MainButton";
import { verifyLength } from "../../Service/Helper/Utils";
import logo from "../../public/img/logo.png";
import { Input } from "reactstrap";


function LoginPages({ state }) {
    const { customerId, setCustomerId, isUseParams, password, setPassword, handleKeyRequest, visible, setVisible, forgotNav, navigation } = state

    return (
        <main className="public-auth-page">
            <section className="public-auth-hero">
                <div className="landing-container public-auth-grid">
                    <div className="public-auth-copy">
                        <div className="landing-brand-chip">
                            <img src={logo} alt="Goodnet Logo" />
                            <span>Goodnet By Artamedia</span>
                        </div>
                        <h1>Login ke portal anda.</h1>
                        <p>Kelola tagihan, pembayaran, dan status layanan internet dari satu tempat.</p>
                        <div className="landing-proof-grid">
                            <div><strong>QRIS / VA</strong><span>Pembayaran praktis</span></div>
                            <div><strong>Riwayat</strong><span>Tagihan tersimpan</span></div>
                            <div><strong>Support</strong><span>Bantuan pelanggan</span></div>
                        </div>
                    </div>

                    <div className="public-auth-card">
                        <div className="public-auth-card-head">
                            <span>Login pelanggan</span>
                            <strong>Masukkan ID layanan</strong>
                        </div>

                        <div className="public-auth-form">
                            <Input
                                className="public-auth-input"
                                placeholder="Nomor Layanan (10 - 12) Digit"
                                value={customerId}
                                disabled={!isUseParams}
                                onChange={(e) => {
                                    if (!verifyLength(e.target.value, 13)) {
                                        setCustomerId(e.target.value)
                                    }
                                }}
                            />
                            <Input
                                className="public-auth-input"
                                placeholder="Masukkan Password"
                                value={password}
                                type={!visible ? "password" : "text"}
                                onChange={(e) => {
                                    if (!verifyLength(e.target.value, 16)) {
                                        setPassword(e.target.value)
                                    }
                                }}
                            />
                        </div>

                        <div className="public-auth-link-row">
                            <button type="button" onClick={() => setVisible(!visible)}>
                                {visible ? "Sembunyikan Password" : "Tampilkan Password"}
                            </button>
                            <button type="button" onClick={forgotNav}>
                                Lupa Password
                            </button>
                            <button type="button" onClick={() => navigation("/register/new")}>
                                Daftar
                            </button>
                        </div>

                        <div className="public-auth-actions">
                            <MainButton
                                title="Masuk"
                                onClick={() => handleKeyRequest(password)}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default LoginPages;
